var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"正在获取数据","show-close":false,"visible":_vm.show_popup}},[_c('div',[_c('el-progress',{attrs:{"text-inside":true,"stroke-width":24,"percentage":_vm.data,"status":"success"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }